import { registerControllers } from "stimulus-vite-helpers";
import { application } from "./application";
const controllers = import.meta.globEager("./**/*_controller.js");
registerControllers(application, controllers);

import Flatpickr from "stimulus-flatpickr";
application.register("flatpickr", Flatpickr);
import { Tabs } from "tailwindcss-stimulus-components";
application.register("tabs", Tabs);
